module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Backward-00a1f95fd48a43b9da171c7085fe2a13.svg";